module.exports = __webpack_public_path__ + "img/tow-truck.7f020132.svg";